type PageHeaderProps = {
  header: string
  description?: string
}

export const PageHeader = ({ header, description }: PageHeaderProps) => {
  if (description) {
    return (
      <>
        <h1>{header}</h1>
        <p>{description}</p>
      </>
    )
  }

  return <h1>{header}</h1>
}
